import {Box, IconButton, Typography} from "@mui/material";
import {Add, Menu} from "@mui/icons-material";
import {useState} from "react";

export default function SideMenu(props) {
    const {
        children,
        onAdd,
        mobile,
    } = props;

    const [open, setOpen] = useState(false);

    return (
        <>
            {mobile && (
                <IconButton onClick={() => setOpen(true)}>
                    <Menu />
                </IconButton>
            )}
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '50px',
                    background: '#141517',
                    zIndex: 400,
                    userSelect: 'none',
                    ...(mobile ? {
                        position: 'fixed',
                        right: 0,
                        top: 0,
                        bottom: 0,
                        zIndex: 500,
                        width: '100vw',
                        transform: open ? '' : 'translateX(100vw)',
                        alignItems: 'flex-end',
                    } : {
                        alignItems: 'flex-start',
                    })
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        height: '60px',
                        width: '60px',
                    }}
                >
                    {mobile ? (
                        <IconButton onClick={() => setOpen(false)}>
                            <Menu />
                        </IconButton>
                    ) : (
                        <IconButton onClick={onAdd} variant="outlined">
                            <Add />
                        </IconButton>
                    )}
                </Box>

                <Box
                    sx={{
                        position: 'absolute',
                        left: !mobile && 0,
                        right: mobile && '15px',
                        top: '80px',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {children?.map?.((item) => {
                        const [icon, label, onClick] = item;

                        return mobile ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignSelf: 'flex-end',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    height: '45px',
                                    background: '#141517',
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    setOpen(false);
                                    onClick?.();
                                }}
                                key={label}
                            >
                                <Typography
                                    mr="30px"
                                    fontFamily={'"Inter"'}
                                    color="#eee"
                                    noWrap
                                >
                                    {label}
                                </Typography>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '50px',
                                        color: '#fff'
                                    }}
                                >
                                    {icon}
                                </Box>
                            </Box>
                        ) : (
                            <Box
                                sx={{
                                    display: 'inline-block',
                                    transition: 'ease-in-out 150ms',
                                    '&:hover': {
                                        transform: 'translateX(calc(-100% + 50px))',
                                        borderLeft: 'solid 1px #444'
                                    }
                                }}
                                onClick={onClick}
                                key={label}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        height: '45px',
                                        background: '#141517',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '50px',
                                            color: '#fff'
                                        }}
                                    >
                                        {icon}
                                    </Box>

                                    <Typography
                                        mr="30px"
                                        fontFamily={'"Inter"'}
                                        color="#eee"
                                        noWrap
                                    >
                                        {label}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
            </Box>
        </>
    );
}